import { useState } from "react";
import { B, PD } from "../theme";
import { SKY } from "../shared/ui";

/* A story-size image made on the device, then the share sheet (or a
   download where sharing files isn't supported). `make` returns the
   result of shareSvgCard: "shared", "cancelled" or "downloaded". */
export function ShareCardButton({ make, label, style }) {
  const [state, setState] = useState("idle");
  const go = async () => {
    setState("working");
    try {
      const r = await make();
      setState(r === "downloaded" ? "saved" : "idle");
      if (r === "downloaded") setTimeout(() => setState("idle"), 2500);
    } catch (e) {
      setState("error");
      setTimeout(() => setState("idle"), 2500);
    }
  };
  return (
    <button type="button" onClick={go} disabled={state === "working"} style={{
      ...B, display: "flex", alignItems: "center", justifyContent: "center", gap: 8, width: "100%",
      minHeight: 48, borderRadius: 999, cursor: "pointer", fontSize: 14, fontWeight: 500,
      color: PD.text, background: "rgba(126,142,194,0.12)", border: `1px solid ${SKY.a}66`, ...style,
    }}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
        <path d="M8 10V2M8 2L5 5M8 2l3 3M3 9v4h10V9" stroke={PD.text} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      {state === "working" ? "Making your card…" : state === "saved" ? "Saved to your downloads" : state === "error" ? "Couldn't make the card. Try again." : label}
    </button>
  );
}
